import React, { Children, Component } from 'react';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var index = createCommonjsModule(function (module) {
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};





var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

// http://stackoverflow.com/a/2117523
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function currentPath(location) {
  var _window$location$loca = window.location[location].slice(1).split('?'),
      _window$location$loca2 = slicedToArray(_window$location$loca, 2),
      windowLocation = _window$location$loca2[0],
      paramString = _window$location$loca2[1];

  var params = (paramString || '').split('&').map(function (param) {
    return param.split('=');
  }).reduce(function (obj, _ref) {
    var _ref2 = slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    obj[key] = val;
    return obj;
  }, {});

  var path = decodeURI(windowLocation);
  return path.charAt(0) !== '/' ? { path: '/' + path, params: params } : { path: path, params: params };
}

function removeTrailingSlash(path) {
  if (path === '/') {
    return path;
  } else {
    return path.slice(-1) !== '/' ? path : path.slice(0, -1);
  }
}

function replaceDynamicSegments(path) {
  return path.replace(/\/:[^\/]+/g, '/([^/]+)');
}

function getDynamicSegmentNames(path) {
  var dynamicSegementNames = path.match(/:[^\/]+/g) || [];
  return dynamicSegementNames.map(function (name) {
    return name.substr(1);
  });
}

function formatPathRegex(basePath, path) {
  return replaceDynamicSegments(removeTrailingSlash(basePath + path) + '/?');
}

function createRegexFromPaths(paths) {
  return new RegExp('^(' + paths.join('|') + ')$');
}

function getSwitch(path, _ref3) {
  var children = _ref3.children,
      basePath = _ref3.basePath;

  var consistentPath = removeTrailingSlash(path);
  var switches = Children.toArray(children);
  return switches.filter(function (child) {
    var childPaths = [].concat(child.props.path).map(function (childPath) {
      return formatPathRegex(basePath, childPath);
    });
    var regex = createRegexFromPaths(childPaths);
    return regex.test(consistentPath);
  })[0] || null;
}

function getActivePath(currentPath, basePath, currentSwitch) {
  if (!currentSwitch) {
    return null;
  }

  var consistentPath = removeTrailingSlash(currentPath);
  var paths = [].concat(currentSwitch.props.path);
  return paths.filter(function (path) {
    var formattedPath = formatPathRegex(basePath, path);
    var regex = new RegExp('^' + formattedPath + '$');
    return regex.test(consistentPath);
  })[0] || null;
}

function getDynamicSegments(path, basePath, swtch) {
  var dynamicValues = {};
  var consistentPath = removeTrailingSlash(path);
  if (swtch) {
    [].concat(swtch.props.path).forEach(function (childPath) {
      var dynamicSegments = getDynamicSegmentNames(basePath + childPath);
      var regexStr = formatPathRegex(basePath, childPath);
      var matches = consistentPath.match(new RegExp('^' + regexStr + '$'));
      if (matches) {
        matches.shift();
        dynamicSegments.forEach(function (segment, index) {
          dynamicValues[segment] = matches[index];
        });
      }
    });
  }
  return dynamicValues;
}

var Switcher = function (_Component) {
  inherits(Switcher, _Component);

  function Switcher(props) {
    classCallCheck(this, Switcher);

    var _this = possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).call(this, props));

    _initialiseProps.call(_this);

    var _currentPath = currentPath(props.location),
        path = _currentPath.path,
        params = _currentPath.params;

    var visibleSwitch = getSwitch(path, props);
    var activePath = getActivePath(path, props.basePath, visibleSwitch);
    var dynamicValues = getDynamicSegments(path, props.basePath, visibleSwitch);
    _this.state = {
      visibleSwitch: visibleSwitch,
      dynamicValues: dynamicValues,
      activePath: activePath,
      params: params
    };
    return _this;
  }

  createClass(Switcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var usingProvider = this.context.switcherProvider;
      if (usingProvider) {
        this._id = generateGuid();
      }

      if (this.props.load) {
        usingProvider ? this.context.switcherProvider.loadListeners.push({
          id: this._id,
          fn: this.handleRouteChange
        }) : window.addEventListener('load', this.handleRouteChange);
      }
      if (this.props.pushState) {
        usingProvider ? this.context.switcherProvider.popStateListeners.push({
          id: this._id,
          fn: this.handleRouteChange
        }) : window.addEventListener('popstate', this.handleRouteChange);
      }
      if (this.props.hashChange) {
        usingProvider ? this.context.switcherProvider.hashChangeListeners.push({
          id: this._id,
          fn: this.handleRouteChange
        }) : window.addEventListener('hashchange', this.handleRouteChange);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.handleSwitchChange(nextProps);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.preventUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      var usingProvider = this.context.switcherProvider;
      if (this.props.load) {
        if (usingProvider) {
          this.context.switcherProvider.loadListeners = this.context.switcherProvider.loadListeners.filter(function (_ref) {
            var id = _ref.id;
            return id !== _this2._id;
          });
        } else {
          window.removeEventListener('load', this.handleRouteChange);
        }
      }
      if (this.props.pushState) {
        if (usingProvider) {
          this.context.switcherProvider.popStateListeners = this.context.switcherProvider.popStateListeners.filter(function (_ref2) {
            var id = _ref2.id;
            return id !== _this2._id;
          });
        } else {
          window.removeEventListener('popstate', this.handleRouteChange);
        }
      }
      if (this.props.hashChange) {
        if (usingProvider) {
          this.context.switcherProvider.hashChangeListeners = this.context.switcherProvider.hashChangeListeners.filter(function (_ref3) {
            var id = _ref3.id;
            return id !== _this2._id;
          });
        } else {
          window.removeEventListener('hashchange', this.handleRouteChange);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref4 = this.state.visibleSwitch || {},
          props = _ref4.props;

      var visibleSwitch = this.state.visibleSwitch && React.cloneElement(this.state.visibleSwitch, _extends({}, props, this.props.mapDynamicSegments(this.state.dynamicValues), {
        activePath: this.state.activePath,
        params: this.state.params
      }));

      if (this.props.renderSwitch) {
        return this.props.renderSwitch(visibleSwitch, this.state.dynamicValues, this.state.activePath, this.state.params);
      }

      if (this.props.wrapper) {
        var passedProps = _extends({}, this.props);
        Object.keys(Switcher.propTypes).forEach(function (k) {
          return delete passedProps[k];
        });
        return React.createElement(this.props.wrapper, passedProps, visibleSwitch);
      } else {
        return visibleSwitch;
      }
    }
  }]);
  return Switcher;
}(Component);

Switcher.displayName = 'Switcher';
Switcher.propTypes = {
  children: index.oneOfType([index.arrayOf(index.node), index.node]),
  pushState: index.bool,
  hashChange: index.bool,
  load: index.bool,
  onChange: index.func,
  wrapper: index.any,
  location: index.string,
  basePath: index.string,
  preventUpdate: index.func,
  mapDynamicSegments: index.func,
  renderSwitch: index.func
};
Switcher.contextTypes = {
  switcherProvider: index.shape({
    loadListeners: index.array.isRequired,
    popStateListeners: index.array.isRequired,
    hashChangeListeners: index.array.isRequired
  })
};
Switcher.defaultProps = {
  pushState: false,
  hashChange: true,
  load: true,
  location: 'hash',
  basePath: '',
  preventUpdate: function preventUpdate() {
    return false;
  },
  mapDynamicSegments: function mapDynamicSegments(values) {
    return values;
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSwitchChange = function (props) {
    var _currentPath2 = currentPath(props.location),
        path = _currentPath2.path,
        params = _currentPath2.params;

    var visibleSwitch = getSwitch(path, props);
    var activePath = getActivePath(path, props.basePath, visibleSwitch);
    var dynamicValues = getDynamicSegments(path, props.basePath, visibleSwitch);

    if (typeof props.onChange === 'function') {
      props.onChange(!!visibleSwitch, path, dynamicValues, activePath, params);
    }

    _this3.setState({ visibleSwitch: visibleSwitch, dynamicValues: dynamicValues, activePath: activePath, params: params });
  };

  this.handleRouteChange = function (ev) {
    _this3.handleSwitchChange(_this3.props);
  };
};

var SwitcherProvider = function (_Component) {
  inherits(SwitcherProvider, _Component);

  function SwitcherProvider() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, SwitcherProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = SwitcherProvider.__proto__ || Object.getPrototypeOf(SwitcherProvider)).call.apply(_ref, [this].concat(args))), _this), _this.switcherProvider = {
      loadListeners: [],
      popStateListeners: [],
      hashChangeListeners: []
    }, _this.handleLoadListeners = function (e) {
      _this.switcherProvider.loadListeners.forEach(function (_ref2) {
        var fn = _ref2.fn;
        return fn(e);
      });
    }, _this.handlePopStateListeners = function (e) {
      _this.switcherProvider.popStateListeners.forEach(function (_ref3) {
        var fn = _ref3.fn;
        return fn(e);
      });
    }, _this.handleHashChangeListeners = function (e) {
      _this.switcherProvider.hashChangeListeners.forEach(function (_ref4) {
        var fn = _ref4.fn;
        return fn(e);
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(SwitcherProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { switcherProvider: this.switcherProvider };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('load', this.handleLoadListeners);
      window.addEventListener('popstate', this.handlePopStateListeners);
      window.addEventListener('hashchange', this.handleHashChangeListeners);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('load', this.handleLoadListeners);
      window.removeEventListener('popstate', this.handlePopStateListeners);
      window.removeEventListener('hashchange', this.handleHashChangeListeners);
    }
  }, {
    key: 'render',
    value: function render() {
      if (Children.count(this.props.children) > 1) {
        return React.createElement(
          'span',
          { className: 'switcher-provider' },
          this.props.children
        );
      } else {
        return this.props.children;
      }
    }
  }]);
  return SwitcherProvider;
}(Component);

SwitcherProvider.displayName = 'SwitcherProvider';
SwitcherProvider.propTypes = {
  children: index.node
};
SwitcherProvider.childContextTypes = {
  switcherProvider: index.shape({
    loadListeners: index.array.isRequired,
    popStateListeners: index.array.isRequired,
    hashChangeListeners: index.array.isRequired
  })
};

export { SwitcherProvider };export default Switcher;
